import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const StepperInglesLargo = ({
  prendidoHasta = 0,
  property2,
  className,
  vector = "/img/vector-41.svg",
}) => {
  const steps = [
    "Enter Employer Indentification Number",
    "Register your Email",
    "Select your product",
    "Accept Terms and Conditions",
    "Validate your identity",
    "Generate your password",
    "Fill in your company information",
    "Attach the required documents",
    "Checkout",
  ];

  return (
    <div className={`stepper-ingles-largo ${className || ""}`}>
      <div className="group">
        <div className="overlap">
          <img className="vector" alt="Vector" src={vector} />
          <img className="img" alt="Vector" src="/img/vector-42.svg" />

          <div className="frame">
            {steps.map((title, index) => {
              const stepNumber = index + 1;
              const isActive = stepNumber <= prendidoHasta;

              return (
                <div className="head" key={stepNumber}>
                  <div className="overlap-group-wrapper">
                    <div
                      className={` overlap-group ${isActive ? "active" : ""}`}
                    >
                      <div className={`number-2 ${isActive ? "active" : ""}`}>
                        {stepNumber}
                      </div>
                    </div>
                  </div>

                  <div
                    className={`title ${stepNumber > 5 ? "title-step" : ""}`}
                  >
                    {title}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

StepperInglesLargo.propTypes = {
  prendidoHasta: PropTypes.number,
  property2: PropTypes.oneOf(["three"]),
  vector: PropTypes.string,
  className: PropTypes.string,
};
